// src/services/walletSettingsService.js

import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/admin-api/v3/admin-settings`;

const walletSettingsService = {
  // GET: Fetch wallet settings
  async getWalletSettings(params = { categoryKey: "wallet_earning_rules" }) {
    try {
      const response = await requestInstance.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching wallet settings:", error);
      throw error;
    }
  },

  // POST: Create wallet settings
  async createWalletSettings(settingData) {
    try {
      const response = await requestInstance.post(BASE_URL, settingData);
      return response.data;
    } catch (error) {
      console.error("Error creating wallet settings:", error);
      throw error;
    }
  },

  // PUT: Update wallet settings
  async updateWalletSettings(settingId, updatedData) {
    try {
      const response = await requestInstance.put(`${BASE_URL}/${settingId}`, updatedData);
      return response.data;
    } catch (error) {
      console.error(`Error updating wallet settings (${settingId}):`, error);
      throw error;
    }
  },
};

export default walletSettingsService;